export const capitalizeFirstLetter = (input: string): string => {
  return input
    ? input.charAt(0).toUpperCase() + input.slice(1).toLowerCase()
    : ''
}

export const capitalizeOnlyFirstLetter = (input: string): string => {
  return input ? input.charAt(0).toUpperCase() + input.slice(1) : ''
}

/**
 * TThis function takes the string and converts the first letter of each word to upper case and the rest of the word to lower case.
 * @param string - string to convert
 * */
export const capitalizeWords = (input: string): string => {
  if (!input) {
    return ''
  }
  return input.toLowerCase().replace(/(?:^|\s)\S/g, (char) => {
    return char.toUpperCase()
  })
}
